import React from 'react';
import { connect } from 'react-redux';
import { parseQs } from 'helpers/http';

import { updateActiveCms } from 'actions/LayoutActions';

import Data from 'components/Data';
import CmsPage from 'components/CmsPage';

import Loader from 'components/layout/Loader';
import withRouter from 'js/withRouter';

class TermsOfService extends React.Component {
  componentDidMount = () => {
    this.props.updateActiveCms('cmsSystemPageTermsOfService');
  };

  componentWillUnmount = () => {
    this.props.updateActiveCms(null);
  };

  render() {
    const { cmsPage, location, height } = this.props;

    const queryParams = parseQs(location.search);
    let pageUrl = '/api/pages/termsofservice.json';
    if (queryParams.owner) {
      pageUrl += 'owner=' + queryParams.owner;
    }

    return (
      <React.Fragment>
        {!cmsPage.data.id && <Data dataName="cmsSystemPageTermsOfService" url={pageUrl} data={cmsPage} />}

        {cmsPage.pending ? (
          <div className="content relative" style={{ height: `${height}px` }}>
            <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%)' }}>
              <Loader />
            </div>
          </div>
        ) : (
          <CmsPage data={cmsPage.data} doUpdateActiveCms={false} />
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    height: state.layout.height,
    cmsPage: state.data.cmsSystemPageTermsOfService,
  };
};
const mapDispatchToProps = dispatch => {
  return {
    updateActiveCms: activeCms => {
      dispatch(updateActiveCms(activeCms));
    },
  };
};

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(TermsOfService));
